export const getTableParams = (t) => {
  const getFields = () => {
    const fields = [{ name: 'name', title: t('grid.Название') }];

    return fields;
  };

  return { getFields };
};
